<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="客户id" prop="uid" >
          <el-input size="small" v-model="addForm.uid" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select class="width-100" size="small" v-model="addForm.status" placeholder="请选择">
            <el-option
              v-for="item in optionStatus"
              size="small"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间区间" prop="dateValue" >
          <el-date-picker
            v-model="addForm.dateValue"
            size="small"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getfeedBackList(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="feedback" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="图片" prop="imul" width="260%">
          <template slot-scope="scope">
          　<el-image
              fit="cover"
              v-for="item in scope.row.imul"
              :key="scope.row.uid"
              style="width: 50px; height: 50px"
              :src="item"
              :preview-src-list="scope.row.imul">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="客户id" prop="uid" width="80%"></el-table-column>
        <el-table-column label="反馈内容" prop="content"></el-table-column>
        <el-table-column label="状态" prop="status" width="80%">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'">未处理</span>
            <span v-else>已处理</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" prop="contactinfo" width="130%"></el-table-column>
        <el-table-column label="反馈时间" prop="created_at" width="180%"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  import { chat_get } from '@/api'

  export default {
    name: 'Feedback',
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        feedback: [],
        total: 0,
        optionStatus: [{
          value: '1',
          label: '已处理'
        }, {
          value: '2',
          label: '未处理'
        }],
        optionType: [{
          value: '1',
          label: '机器人'
        }, {
          value: '2',
          label: '客服'
        }],
        addForm: {
          uid: '',
          // el-select选项值
          status: '',
          startTime: '',
          endTime: '',
          dateValue: []
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
      this.getfeedBackList()
    },
    methods: {
      getfeedBackList(val = false) {
        if (val) this.queryInfo.pagenum = 1;
        let { uid, status, startTime, endTime } = this.addForm;
        chat_get(`/admin/v1/feedbackList?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&uid=${uid}&status=${status}&created_start_at=${startTime}&created_end_at=${endTime}`, {}, res => {
          if (res.status == 200) {
            let { count, feedBackList } = res.data
            this.total = count
            if(!feedBackList) this.feedback = []
            this.feedback = feedBackList.map(item => {
              item.imul = JSON.parse(item.imul)
              return item;
            })
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getfeedBackList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getfeedBackList()
      },
      resetInput() {
        this.$refs.addFormRef.resetFields()
        this.addForm.startTime = ''
        this.addForm.endTime = ''
        this.getfeedBackList()
      },
      dateRangeChange() {
        this.addForm.startTime = this.addForm.dateValue ? this.addForm.dateValue[0] : ''
        this.addForm.endTime = this.addForm.dateValue ? this.addForm.dateValue[1] : ''
        this.getfeedBackList(true)
      },
    }
  }
</script>

<style scoped>
.el-icon-circle-close {
  color: white !important;
}
</style>
